import React from "react";
import {TrainingContent} from "../../common/webapicall";
import TrainingContentCard from "./training.content.card";

interface Props {
	trainingContents: TrainingContent[];
}

const TrainingContentList: React.FC<Props> = ({trainingContents}: Props) => {
	const getUniqueKey = (id: string, taxonomy: string) => `${id}-${taxonomy}`;

	if (trainingContents.length === 0) {
		return <div>No My Learning Assets</div>;
	}

	return (
		<div className="cih-training-content-cards">
			{trainingContents.map((t) => (
				<TrainingContentCard key={getUniqueKey(t.id, t.taxonomyName)} trainingContent={t} />
			))}
		</div>
	);
};

export default TrainingContentList;
